import React from 'react'
import Header from '../../components/header'
import ClientForm from '../../components/client-form'
import Spacer from '../../components/spacer'
import css from './style.css'

const Client = props => (
  <div>
    <div className={css.background} />
    <Spacer xs />
    <div className={css.content}>
      <Header subtitle='Help us confirm your details.'>
        Client Profile
      </Header>
      <Spacer xxs />
      <ClientForm />
    </div>
  </div>
)

export default Client



// WEBPACK FOOTER //
// ./src/containers/client/index.js